import { List } from "@mui/material";
import { FC } from "react";
import { PushNotificationSubscriptionsLoader } from "./PushNotificationSubscriptionsLoader";
import { SubscriptionItem } from "./SubscriptionItem";
import { WebSubscriptionDto } from "./WebSubscription";

export interface PushNotificationSubscriptionListProps {
  onUnsubscribe: (subscription: WebSubscriptionDto) => void;
}

export const PushNotificationSubscriptionList: FC<
  PushNotificationSubscriptionListProps
> = (props) => {
  return (
    <PushNotificationSubscriptionsLoader>
      {(result) => {
        return (
          <List>
            {result.data?.webSubscriptions.map((it, index) => {
              return (
                <SubscriptionItem
                  subscription={it}
                  key={index}
                  onRemove={props.onUnsubscribe}
                />
              );
            })}
          </List>
        );
      }}
    </PushNotificationSubscriptionsLoader>
  );
};
